// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iHd9e","title":"styles_title__2A_Lw"};